import React, { lazy, Suspense } from "react";
import "./Project.css";
import Button from "../../components/button/Button";
import Loading from "../loading/Loading";
import { githubProjects, socialMediaLinks } from "../../portfolio";

export default function Projects() {
  const GithubRepoCard = lazy(() => import('../../components/githubRepoCard/GithubRepoCard'));
  const FailedLoading = () => null ;
  const renderLoader = () => <Loading />;
  // const [repo, setrepo] = useState([]);
  const repo = githubProjects;
  if (!(typeof repo === 'string' || repo instanceof String)){
    console.log(repo)
  return (
    <Suspense fallback={renderLoader()}>
      <div className="main" id="featured-projects">
        <h1 className="project-title">Featured Projects</h1>
        {/* <pre>
          {JSON.stringify(githubProjects,"",2)}
        </pre> */}
        <div className="repo-cards-div-main">
          {repo.map((v, i) => {
            return <GithubRepoCard repo={v} key={i} />;
          })}
        </div>
        <Button text={"More Projects"} className="project-button" href={socialMediaLinks.github} newTab={true} />
      </div>

    </Suspense>
  );
} else{
    return(<FailedLoading />);
  }
}